/*=========================================================================================
  File Name: mutations.js
  Namespace: labs
  Description: Vuex Store - Lab mutations
==========================================================================================*/
import { buildLabState } from './state'

const sortByOrder = (arr) => arr.sort((a, b) => a.order - b.order)

const mutations = {
  STORE_CURRENT_LAB(state, lab) {
    state.currentLab = { ...state.currentLab, ...lab }
  },
  RESET_CURRENT_LAB(state) {
    state.currentLab = buildLabState()
    state.objectives = []
  },
  STORE_LIST_LABS(state, labs) {
    state.labList = {
      ...state.labList,
      ...labs.entries,
    }
    state.count = labs.count
    state.next = labs.next
    state.previous = labs.previous
    state.results = [...labs.results]
  },
  STORE_LIST_OBJECTIVES(state, objectives) {
    state.objectives = sortByOrder(objectives)
  },
  STORE_OBJECTIVE(state, objective) {
    const { objectives } = state

    const oIndex = objectives.findIndex((o) => o.id == objective.id)

    if (oIndex == -1) {
      //NEW OBJECTIVE
      objectives.push(objective)
    } else {
      //UPDATE OBJECTIVE
      objectives.splice(oIndex, 1, objective)
    }

    sortByOrder(objectives)
  },
  DELETE_OBJECTIVE(state, payload) {
    const oIndex = state.objectives.findIndex((o) => o.id == payload.id)

    state.objectives.splice(oIndex, 1)
  },
  STORE_LAB_TO_LIST(state, lab) {
    state.labList = {
      ...state.labList,
      ...lab,
    }
  },
  STORE_CATEGORY_LIST(state, categories) {
    state.categoryList = {
      ...state.categoryList,
      ...categories.entries
    }
    state.categoryPagination = {
      count: categories.count,
      next: categories.next,
      previous: categories.previous,
      results: categories.results ? [...state.results, ...categories.results] : null
    }
  },
  RESET_CATEGORIES(state) {
    state.categoryList = {}
  },
  STORE_CURRENT_FLAGS(state, flags) {
    state.currentLab.flags = [...flags]
  },
  ADD_TO_CURRENT_LAB_TAXONOMY_SKILLS(state, skill) {
    const currentSkills = state.currentLab.taxonomy_skills || []
    state.currentLab.taxonomy_skills = [...currentSkills, skill]
  }
}

export default mutations
